import {
	Box,
	Button,
	Center,
	Group,
	Image,
	AppShell,
	useMantineTheme,
	PasswordInput,
	Text,
	TextInput,
	Container,
	Loader,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import googleicon from "../../static/svg/google-icon.svg";
import imageIcon from "../../static/svg/ivistlogin.svg";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { showErrorNotification } from "../../utils/Notifications";
import { showSuccessNotification } from "../../utils/Notifications";
import Footr from "../../components/Footr";
import { useState } from "react";
import siginupUser from "../../API/signupUser";
function Signup() {
	const theme = useMantineTheme();
	const [loading, setLoading] = useState(false);
	const navigator = useNavigate();
	const dispatch = useDispatch();
	const form = useForm({
		initialValues: {
			FirstName: "",
			LastName: "",
			password: "",
			Email: "",
			AuthTypeId: 1,
		},

		validate: {
			Email: (value) =>
				/^\S+@\S+$/.test(value) ? null : "Invalid email",
			FirstName: (value) =>
				value.length < 2 ? "Name must have at least 2 letters" : null,
			LastName: (value) =>
				value.length < 2 ? "Name must have at least 2 letters" : null,
			password: (value) => (value.length < 8 ? "Max 8 char" : null),
			confirmPassword: (value, values) =>
				value !== values.password ? "Passwords did not match" : null,
		},
	});
	const signupFormHandler = form.onSubmit(async (signupData) => {
		setLoading(true);
		const response = await siginupUser(signupData);
		setLoading(false);
		if (response === "Email already exist ") {
			showErrorNotification("Email already exist");
		} else if (response === "Email already exist but soft delete") {
			showErrorNotification("Email already exist but soft delete");
			navigator("/enableSignup");
		} else {
			showSuccessNotification("SignUp Successfuly");
			navigator("/login");
		}
	});
	return (
		<AppShell
			styles={{
				main: {
					position: "relative",
					minHeight: "calc(100vh - 48px)",
					maxHeight: "auto",

					background:
						theme.colorScheme === "dark"
							? theme.colors.ivisit_dark[0]
							: theme.colors.gray[0],
				},
			}}
			footer={<Footr />}
		>
			<div
				style={{
					background: "#040F1F",
					margin: "auto",
				}}
			>
				<ToastContainer />
				<Container className="signupForm" size="xs" px="xs">
					<Group position="center" align="center">
						<Image src={imageIcon} width={270} pb={30} pt={50} />
					</Group>
					<Text
						align="center"
						color="white"
						size="xl"
						weight={1000}
						pb={20}
						style={{ fontFamily: "SFPro Display ", color: "white" }}
					>
						Sign Up
					</Text>
					<Box sx={{ maxWidth: 340 }} mx="auto">
						<form onSubmit={signupFormHandler}>
							<Center>
								<TextInput
									className="inpMargin"
									required
									mr={10}
									styles={{
										input: { backgroundColor: "#252E3D" },
										root: {
											width: "100%",
											color: "white",
										},
									}}
									placeholder="First Name"
									{...form.getInputProps("FirstName")}
								/>

								<TextInput
									className="inpMargin"
									required
									styles={{
										input: { backgroundColor: "#252E3D" },
										root: {
											width: "100%",
											color: "white",
										},
									}}
									placeholder="Last Name"
									{...form.getInputProps("LastName")}
								/>
							</Center>

							<TextInput
								className="inpMargin"
								required
								styles={{
									input: { backgroundColor: "#252E3D" },
									root: {
										width: "100%",
										color: "white",
									},
								}}
								placeholder="Email"
								{...form.getInputProps("Email")}
							/>

							<PasswordInput
								className="inpMargin"
								{...form.getInputProps("password")}
								styles={{
									input: { backgroundColor: "#252E3D" },
									root: {
										width: "100%",
										color: "white",
									},
								}}
								placeholder="password"
							/>
							<PasswordInput
								className="inpMargin"
								{...form.getInputProps("confirmPassword")}
								styles={{
									input: { backgroundColor: "#252E3D" },
									root: {
										width: "100%",
										color: "white",
									},
								}}
								placeholder="Confirm Password"
							/>
							<Group className="inpMargin" position="center">
								<Button
									style={{ width: "340px" }}
									type="submit"
								>
									Sign Up
								</Button>
							</Group>

							<Group className="inpMargin" position="center">
								<Button
									style={{ width: "340px", color: "white" }}
									variant="outline"
									type="submit"
									component="a"
									target="_blank"
									rel="noopener noreferrer"
									href="https://google.com/"
								>
									<Image
										src={googleicon}
										width={12}
										px={20}
									/>
									Continue with Google
								</Button>
							</Group>
							<Group className="inpMargin" position="center">
								<Text align="center" color="rgb(173, 181, 189)">
									Already have an account?
								</Text>
							</Group>
							<Group className="inpMargin" position="center">
								<Link
									style={{
										width: "100%",
										border: "1px solid #14B8E1",
										background: " none",
										color: "white",
										textDecoration: "none",
										textAlign: "center",
										padding: "5px",
										borderRadius: "5px",
									}}
									to="/login"
								>
									Login
								</Link>
							</Group>
						</form>
					</Box>
				</Container>
			</div>
			{loading && (
				<div className="LoadingModal">
					<Loader className="LoadingModal_loader" />
				</div>
			)}
		</AppShell>
	);
}
export default Signup;
